import { FC } from "react";

import styles from "./styles/ToolSettingsModal.module.css";

export interface StylePickerValue {
  color: string;
  opacity: number;
  width?: number;
}

const COLORS = [
  "#22c55e",
  "#ef4444",
  "#3b82f6",
  "#f59e0b",
  "#8b5cf6",
  "#06b6d4",
  "#f97316",
  "#ffffff",
];

const WIDTHS = [1, 2, 3, 4, 5];

interface Props {
  value: StylePickerValue;
  onChange: (value: StylePickerValue) => void;
  showWidth?: boolean;
  showOpacity?: boolean;
}

export const LineStylePicker: FC<Props> = ({
  value,
  onChange,
  showWidth = true,
  showOpacity = true,
}) => (
  <div className={styles.picker}>
    <p className={styles.pickerLabel}>Line color</p>
    <div className={styles.colorGrid}>
      {COLORS.map((color) => (
        <button
          key={color}
          className={`${styles.colorSwatch} ${value.color === color ? styles.colorSwatchActive : ""}`}
          style={{ backgroundColor: color }}
          onClick={() => onChange({ ...value, color })}
          aria-label={color}
        />
      ))}
    </div>

    {showWidth && (
      <>
        <p className={styles.pickerLabel}>Line width</p>
        <div className={styles.widthRow}>
          {WIDTHS.map((w) => (
            <button
              key={w}
              className={`${styles.widthBtn} ${value.width === w ? styles.widthBtnActive : ""}`}
              onClick={() => onChange({ ...value, width: w })}
            >
              {w}px
            </button>
          ))}
        </div>
      </>
    )}

    {showOpacity && (
      <>
        <p className={styles.pickerLabel}>Opacity</p>
        <input
          type="range"
          min={0}
          max={100}
          value={value.opacity}
          className={styles.opacitySlider}
          onChange={(e) =>
            onChange({ ...value, opacity: Number(e.target.value) })
          }
        />
      </>
    )}
  </div>
);
